import { Button } from '@/components/ui/button';

interface CookieSettingsButtonProps {
  className?: string;
  variant?: 'link' | 'ghost';
  size?: 'default' | 'sm';
}

export function CookieSettingsButton({
  className,
  variant = 'link',
  size = 'sm',
}: CookieSettingsButtonProps) {
  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      className={className}
      onClick={() => {
        window.dispatchEvent(new CustomEvent('open-cookie-settings'));
      }}
    >
      Cookies
    </Button>
  );
}
